module.exports = __webpack_public_path__ + "img/oval.06f3ed6e.svg";